/**
 * Get all charts' information modal content
 * @return null || modal
 */

 const getAllChartsInfoModalContent = state => state.modal.allChartsInfoModalContent;

 export default getAllChartsInfoModalContent;
 
 